export const emojiObject = {
    "😂": "Face with Tears of Joy",
    "😭": "Loudly Crying Face",
    "🥺": "Pleading Face",
    "🤣": "Rolling on the Floor Laughing",
    "❤️": "Red Heart",
    "✨": "Sparkles",
    "😍": "Smiling Face with Heart-Eyes",
    "🙏": "Folded Hands",
    "😊": "Smiling Face with Smiling Eyes",
    "🥰": "Smiling Face with Hearts",
    "👍": "Thumbs Up",
    "💕": "Two Hearts",
    "🤔": "Thinking Face",
    "😲": "Astonished Face",
    "😘": "Face Blowing A Kiss",
    "😒": "Unamused Face",
    "😩": "Weary Face",
    "😏": "Smirking Face",
    "😁": "Beaming Face With Smiling Eyes",
    "😳": "Flushed Face",
    "🙈": "See No Evil Monkey",
    "😔": "Pensive Face",
    "😑": "Expressionless Face",
    "😋": "Face Savoring Food ",
    "😞": "Disappointed Face",
};